import styled from 'styled-components';

export const FormGroup = styled.div`
  padding: 5px 0;
  margin-bottom: 10px;
  > label {
    margin-bottom: 5px;
  }
`;

export default FormGroup;
